module.exports = __webpack_public_path__ + "img/competencies_quality_swiper_02.988dc7e3.jpg";